import React, { Component } from 'react';
import { DataHeading, BoldFont } from './styles';

class TitleNode extends Component {
  constructor(props) {
    super(props);
    this.formatTitle = this.formatTitle.bind(this);
  }

  formatTitle(each) {
    return each
      .split(/(?=[A-Z])/)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1))
      .join(' ');
  }

  render() {
    const { title } = this.props;
    return (
      <BoldFont data-test="transaction-summary-titleNode">
        {
          (title === "Transaction ID" || title ==="NAV")
            ?
            <DataHeading>{title}</DataHeading>
            :
            <DataHeading>{this.formatTitle(title)}</DataHeading>
        }
      </BoldFont>
    );
  }
}

export default TitleNode;
